import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'

class IndexBloc {

    listChannel = new Subject()
    createChannel = new Subject()
    listDetailChannel = new Subject()
    listPegawaiChannel = new Subject()
    listUnitKerjaChannel = new Subject()
    listJabatanChannel = new Subject()
    inactiveChannel = new Subject()
    inactiveDetailChannel = new Subject()
    detailChannel = new Subject()
    detailMutasiChannel = new Subject()
    regionChannel = new Subject()
    tmtStartChannel = new Subject()
    tmtEndChannel = new Subject()
    uploadDecreeChannel = new Subject()
    updateSuratKeputusanChannel = new Subject()
    updateSPKeluargaChannel = new Subject()
    updateSppChannel = new Subject()
    updateSpmjChannel = new Subject()
    updateSpmtChannel = new Subject()

    coupleChannel = new Subject()
    childChannel = new Subject()
    
    cekMandatoryChannel = new Subject()
    exportChannel = new Subject()

    repository = new IndexRepository()

    constructor() {
        this.listChannel.next({status: apiResponse.INITIAL})
        this.createChannel.next({status: apiResponse.INITIAL})
        this.listDetailChannel.next({status: apiResponse.INITIAL})
        this.listPegawaiChannel.next({status: apiResponse.INITIAL})
        this.listUnitKerjaChannel.next({status: apiResponse.INITIAL})
        this.listJabatanChannel.next({status: apiResponse.INITIAL})
        this.inactiveChannel.next({status: apiResponse.INITIAL})
        this.inactiveDetailChannel.next({status: apiResponse.INITIAL})
        this.detailChannel.next({status: apiResponse.INITIAL})
        this.detailMutasiChannel.next({status: apiResponse.INITIAL})
        this.regionChannel.next({status: apiResponse.INITIAL})
        this.tmtStartChannel.next({status: apiResponse.INITIAL})
        this.tmtEndChannel.next({status: apiResponse.INITIAL})
        this.uploadDecreeChannel.next({status: apiResponse.INITIAL})
        this.updateSuratKeputusanChannel.next({status: apiResponse.INITIAL})
        this.updateSPKeluargaChannel.next({status: apiResponse.INITIAL})
        this.updateSppChannel.next({status: apiResponse.INITIAL})
        this.updateSpmjChannel.next({status: apiResponse.INITIAL})
        this.updateSpmtChannel.next({status: apiResponse.INITIAL})
        this.cekMandatoryChannel.next({status: apiResponse.INITIAL})
        this.exportChannel.next({status: apiResponse.INITIAL})
        
    }

    fetchCreate = async (query) => {
        try {
            this.createChannel.next({status: apiResponse.LOADING})
            const result = await this.repository.fetchCreate(query)
            this.createChannel.next({status: apiResponse.COMPLETED, data: result})
        } catch (e) {
            this.createChannel.next({status: apiResponse.ERROR, data: e})
        }
    }

    fetchList = async (query) => {
        try {
            this.listChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchList(query).then((result) => {
                this.listChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.listChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }

    fetchListDetail = async (query) => {
        try {
            this.listDetailChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchListDetail(query).then((result) => {
                this.listDetailChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.listDetailChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }

    fetchListPegawai = async (query) => {
        try {
            this.listPegawaiChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchListPegawai(query).then((result) => {
                this.listPegawaiChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.listPegawaiChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }

    fetchListUnitKerja = async (query) => {
        try {
            this.listUnitKerjaChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchListUnitKerja(query).then((result) => {
                this.listUnitKerjaChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.listUnitKerjaChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }


    fetchListJabatan = async (query) => {
        try {
            this.listJabatanChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchListJabatan(query).then((result) => {
                this.listJabatanChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.listJabatanChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }

    fetchInactive = async (query) => {
        try {
            this.inactiveChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchInactive(query).then((result) => {
                this.inactiveChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.inactiveChannel.next({ status: apiResponse.ERROR, data: error })
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchInactiveDetail = async (query) => {
        try {
            this.inactiveDetailChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchInactiveDetail(query).then((result) => {
                this.inactiveDetailChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.inactiveChannel.next({ status: apiResponse.ERROR, data: error })
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchDetail = async (query) => {
        try {
            this.detailChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.detailChannel.next({ status: apiResponse.ERROR, data: error })
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchDetailMutasi = async (query) => {
        try {
            this.detailMutasiChannel.next({ status: apiResponse.LOADING })
            await this.repository.fetchDetailMutasi(query).then((result) => {
                this.detailMutasiChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.detailMutasiChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchRegion = async (query) => {
        try {
            this.regionChannel.next({ status: apiResponse.LOADING})
            await this.repository.fetchRegion(query).then((result) => {
                this.regionChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.regionChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Error fetching region')
        }
    }

    fetchTMTEnd = async (query) => {
        try {
            this.tmtEndChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchTMTEnd(query).then((result) => {
                this.tmtEndChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.tmtEndChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }
    fetchTMTStart = async (query) => {
        try {
            this.tmtStartChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchTMTStart(query).then((result) => {
                this.tmtStartChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.tmtStartChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }

    ftechUploadDecree = async (query) => {
        try {
            this.uploadDecreeChannel.next({status: apiResponse.LOADING})
            await this.repository.ftechUploadDecree(query).then((result) => {
                this.uploadDecreeChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.uploadDecreeChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }
    fetchUpdateSuratKeputusan = async (query) => {
        try {
            this.updateSuratKeputusanChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchUpdateSuratKeputusan(query).then((result) => {
                this.updateSuratKeputusanChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.updateSuratKeputusanChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }
    fetchUpdateSPKeluarga = async (query) => {
        try {
            this.updateSPKeluargaChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchUpdateSPKeluarga(query).then((result) => {
                this.updateSPKeluargaChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.updateSPKeluargaChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }
    fetchUpdateSpp = async (query) => {
        try {
            this.updateSppChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchUpdateSpp(query).then((result) => {
                this.updateSppChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.updateSppChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }
    fetchUpdateSpmj = async (query) => {
        try {
            this.updateSpmjChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchUpdateSpmj(query).then((result) => {
                this.updateSpmjChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.updateSpmjChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }
    fetchUpdateSpmt = async (query) => {
        try {
            this.updateSpmtChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchUpdateSpmt(query).then((result) => {
                this.updateSpmtChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.updateSpmtChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }
    fetchCouple = async (query) => {
        try {
            this.coupleChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCouple(query).then((result) => {
                this.coupleChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.coupleChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }    
    fetchChild = async (query) => {
        try {
            this.childChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchChild(query).then((result) => {
                this.childChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.childChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }
    fetchcekMandatory = async (query) => {
        try {
            this.cekMandatoryChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchcekMandatory(query).then((result) => {
                this.cekMandatoryChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.cekMandatoryChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }
    fetchExport = async (query) => {
        try {
            this.exportChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchExport(query).then((result) => {
                this.exportChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }
    
}

export default IndexBloc